<template>
  <div class="asset-table">
    <v-data-table
      :headers="headers"
      :items="adminAssetTypeList"
      item-key="id"
      sort-by="id"
      :sort-desc="true"
      :loading="tableLoader"
      loading-text="Fetching Asset Types..."
      :expanded.sync="expanded"
      show-expand
      class="mb-12 elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Asset Types</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Create Asset Modal -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                New Asset Type
              </v-btn>
            </template>
            <AssetTypeForm
              v-on:dialog-close="dialog = false"
            ></AssetTypeForm>
          </v-dialog>

          <!-- Edit Type Modal -->
          <v-dialog
            v-model="editDialog"
            max-width="500px"
          >
            <v-card>
              <AssetTypeForm
                v-on:dialog-close="editDialog = false"
              ></AssetTypeForm>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon
          small
          @click="editType(item.id)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="item.id !== 1"
          small
          @click="deleteAssetType(item.id)"
        >
          mdi-delete
        </v-icon>
        <v-icon
          v-else
          small
        >
          mdi-delete-off
        </v-icon>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <div
            v-if="item.metadataDefinitions.length > 0"
            class="py-2"
          >
            Metadata:
            <v-chip
              v-for="(meta, m) in item.metadataDefinitions"
              :key="m"
              small
              class="ml-2 my-1"
            >
            <strong>{{ meta.title }}</strong>
            <span class="pl-1">({{ meta.type }})</span>
            </v-chip>
          </div>
          <span v-else> There is no added metadata.</span>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import AssetTypeForm from './AssetTypeForm.vue'

  export default {
    name: 'AssetTypeTable',

    components: {
      AssetTypeForm
    },

    data: () => ({
      tableLoader: true,
      dialog: false,
      editDialog: false,
      expanded: [],

      // Mapping datatable.
      headers: [
        {
          text: 'ID',
          value: 'id',
          align: 'start'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'end',
          sortable: false
        }
      ]
    }),

    methods: {
      ...mapActions([
        'getAssetTypes',
        'getAssetType',
        'deleteAssetType'
      ]),

      editType: async function (editTypeId) {
        // Set the type to edit.
        await this.getAssetType(editTypeId)

        // Open the dialogue.
        this.editDialog = true
      }
    },

    computed: {
      ...mapGetters(['adminAssetTypeList'])
    },

    created() {
      // Try to fetch the list of asset-types.
      this.getAssetTypes().then(() => {
        this.tableLoader = false
      })
    }
  }
</script>
